import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jszx",
  "use": "icon-jszx-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-jszx\">\n<g id=\"icon-jszx_Menu/jszx\">\n<g id=\"icon-jszx_Group 7\">\n<path id=\"icon-jszx_Rectangle 51\" d=\"M2 4.5H8V5.5H2V4.5Z\" fill=\"#282C33\" />\n<rect id=\"icon-jszx_Rectangle 54\" x=\"9\" y=\"10\" width=\"5\" height=\"1\" fill=\"#282C33\" />\n<rect id=\"icon-jszx_Rectangle 55\" x=\"9\" y=\"13\" width=\"5\" height=\"1\" fill=\"#282C33\" />\n<rect id=\"icon-jszx_Rectangle 53\" x=\"2.19385\" y=\"13.3398\" width=\"15.9447\" height=\"1\" transform=\"rotate(-45 2.19385 13.3398)\" fill=\"#282C33\" />\n<path id=\"icon-jszx_Rectangle 52\" d=\"M4.5 8V2H5.5V8H4.5Z\" fill=\"#282C33\" />\n</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/jszx.svg
// module id = fFm7
// module chunks = 140